class NumberParser {
  private _group: RegExp;
  private _decimal: RegExp;
  private _numeral: RegExp;
  private _index: (d: string) => number | undefined;
  private _currency: RegExp;

  constructor(locale: string, currency: string) {
    const parts = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      notation: "standard",
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 1
    }).formatToParts(12345.6);
    const numerals = Array.from(
      new Intl.NumberFormat(locale, { useGrouping: false }).format(9876543210)
    ).reverse();
    const index = new Map(numerals.map((d, i) => [d, i]));
    this._group = new RegExp(
      `[${parts.find((d) => d.type === "group")?.value}]`,
      "g"
    );
    this._decimal = new RegExp(
      `[${parts.find((d) => d.type === "decimal")?.value}]`
    );
    this._numeral = new RegExp(`[${numerals.join("")}]`, "g");
    this._index = (d) => index.get(d);
    this._currency = new RegExp(
      `[${parts.find((d) => d.type === "currency")?.value}]`,
      "g"
    );
  }

  parse(string: string): number {
    return (string = string
      .trim()
      .replace(this._group, "")
      .replace(this._currency, "")
      .replace(this._decimal, ".")
      .replace(this._numeral, (d) => String(this._index(d)))).trim()
      ? +string
      : NaN;
  }
}

export default NumberParser;
